import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {DashboardNewView} from '../views/DashboardNewView';
import {DashboardMiniView} from '../views/DashboardMiniView';
import {DashboardMobileView} from '../views/DashboardMobileView';
import {DashboardMiniMobileView} from '../views/DashboardMiniMobileView';

export interface IDashboardMainViewProps {
    dashboardMainStore?: {
        controller: any;
        isMobile: boolean;
    };
}

/**
 * Desktop view for dashboard/main route.
 * Conditionally renders DashboardNewView or DashboardMiniView
 * based on the controller's miniDashboard flag.
 */
@observer
class DashboardMainDesktopViewComponent extends TechseeBaseComponent<IDashboardMainViewProps> {
    renderInternal(): JSX.Element {
        const {dashboardMainStore} = this.props;
        const controller = dashboardMainStore?.controller;

        if (!controller) {
            return <React.Fragment />;
        }

        if (controller.miniDashboard) {
            return <DashboardMiniView dashboard={controller} />;
        }

        return <DashboardNewView dashboard={controller} />;
    }
}

export const DashboardMainDesktopView = inject('dashboardMainStore')(
    DashboardMainDesktopViewComponent
) as IReactComponent;

/**
 * Mobile view for dashboard/main route.
 * Conditionally renders DashboardMobileView or DashboardMiniMobileView
 * based on the controller's miniDashboard flag.
 */
@observer
class DashboardMainMobileViewComponent extends TechseeBaseComponent<IDashboardMainViewProps> {
    renderInternal(): JSX.Element {
        const {dashboardMainStore} = this.props;
        const controller = dashboardMainStore?.controller;

        if (!controller) {
            return <React.Fragment />;
        }

        if (controller.miniDashboard) {
            return <DashboardMiniMobileView dashboard={controller} />;
        }

        return <DashboardMobileView dashboard={controller} />;
    }
}

export const DashboardMainMobileView = inject('dashboardMainStore')(
    DashboardMainMobileViewComponent
) as IReactComponent;
